module.exports = __webpack_public_path__ + "img/eth_logo.aa26ae0b.png";